import { createFileRoute } from "@tanstack/react-router";
import { EventCard } from "@/components/EventCard";
import type { PulseEvent } from "@/lib/events";

export const Route = createFileRoute("/dev/eventcard-qa")({
  component: EventCardQaPage,
  head: () => ({
    meta: [{ name: "robots", content: "noindex" }],
  }),
});

const IMG =
  "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=700";

function fixture(partial: Partial<PulseEvent> & Pick<PulseEvent, "id" | "name">): PulseEvent {
  return {
    city: "Zurich",
    venue: "Sender Club",
    venueId: null,
    venueAddress: null,
    time: "23:00",
    price: "",
    distance: "1.2 km",
    distanceKm: 1.2,
    category: "Clubs",
    image: IMG,
    imageAlternates: [IMG],
    live: false,
    savedCount: 86,
    ticketsSold: 0,
    capacity: 100,
    popular: false,
    description: "QA fixture",
    descriptionDe: null,
    descriptionEn: null,
    descriptionFr: null,
    descriptionIt: null,
    lineup: ["Helena Voss", "DJ Marec"],
    dressCode: "Smart",
    opens: "22:00",
    starts: "23:00",
    ends: "05:00",
    schedule: "Heute · 23:00",
    coords: { x: 0, y: 0 },
    lat: 47.39,
    lng: 8.52,
    entryPrice: 38.4,
    currency: "CHF",
    startsAtIso: new Date().toISOString().replace(/T.*/, "T23:00:00+02:00"),
    endsAtIso: null,
    createdAt: new Date().toISOString(),
    rating: 4.5,
    pulseRating: 4.5,
    pulseRatingCount: 12,
    musicStyle: "Electronic / Techno",
    genres: ["Electronic / Techno"],
    gallery: [IMG],
    isOutdoor: false,
    openingHours: [],
    isTopPick: false,
    isPopular: false,
    isNew: false,
    status: "published",
    storedMusicStyle: "Techno",
    storedGenres: ["Techno"],
    ...partial,
  };
}

const CASES: { label: string; event: PulseEvent }[] = [
  {
    label: "Live + Top Pick (Achievement) · Preis mit 2 Decimals",
    event: fixture({
      id: "qa-live-top",
      name: "Boiler Room: Techno Night",
      live: true,
      isTopPick: true,
      entryPrice: 38.4,
      savedCount: 86,
    }),
  },
  {
    label: "Selling Fast (≥60%) + Popular · CHF 25.00",
    event: fixture({
      id: "qa-selling-fast",
      name: "Sunset Sessions",
      venue: "Kosmos Rooftop",
      ticketsSold: 80,
      capacity: 100,
      popular: true,
      isPopular: true,
      entryPrice: 25,
      savedCount: 142,
      genres: ["Electronic / Techno"],
      storedMusicStyle: "House",
    }),
  },
  {
    label: "entry_price = NULL → keine Preiszeile",
    event: fixture({
      id: "qa-null-price",
      name: "Open Deck Night",
      entryPrice: null,
      currency: null,
      live: false,
      createdAt: new Date().toISOString(),
      savedCount: 12,
    }),
  },
];

function EventCardQaPage() {
  if (!import.meta.env.DEV) {
    return (
      <div className="grid min-h-screen place-items-center p-6 text-sm text-muted-foreground">
        Nur im Dev-Modus verfügbar.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--vc-obsidian,#08080a)] px-5 py-8">
      <p
        className="mb-2 font-mono text-[10px] uppercase tracking-[0.14em] text-[var(--vc-steel-dim,#5c5f68)]"
        data-testid="eventcard-qa-banner"
      >
        Dev QA · echte EventCard-Komponente · Fixtures (Prod hat aktuell 0 Live / 0 Ticket-Sales)
      </p>
      <h1
        className="mb-6 text-[26px] font-normal text-[var(--vc-platinum,#edeef1)]"
        style={{ fontFamily: "var(--vc-font-display, Fraunces, serif)" }}
      >
        EventCard QA
      </h1>
      <div className="mx-auto flex w-full max-w-[390px] flex-col gap-4">
        {CASES.map(({ label, event }) => (
          <div key={event.id} data-testid={`qa-case-${event.id}`}>
            <p className="mb-2 font-mono text-[10px] text-[var(--vc-steel-dim,#5c5f68)]">{label}</p>
            <EventCard event={event} isInterested={false} />
          </div>
        ))}
      </div>
    </div>
  );
}
